import * as ArticleComponents from './components/index';
export const Article = ArticleComponents;